import { PimResource } from "./pim-resource.js";
import * as PIM from "../pim-vocabulary.js";
/**
 * An attribute is a primitive property that belongs to a class. It may be
 * a string, integer etc.
 */
export class PimAttribute extends PimResource {
    static TYPE = PIM.ATTRIBUTE;
    pimDatatype = null;
    // If pimDataType is languageString, then this is the list of required languages
    pimLanguageStringRequiredLanguages = [];
    pimOwnerClass = null;
    pimCardinalityMin = null;
    pimCardinalityMax = null;
    pimRegex = null;
    pimExample = null;
    constructor(iri = null) {
        super(iri);
        this.types.push(PimAttribute.TYPE);
    }
    static is(resource) {
        return resource?.types.includes(PimAttribute.TYPE);
    }
}
//# sourceMappingURL=pim-attribute.js.map